<template>
  <div id="addressCreate" v-show="adc_show === 1">
    <div :class="{ 'ade-model': true, 'ade-model-show': adc_show === 1 }">
      <!-- 视觉区域 -->

      <!-- 面板 -->
      <div class="ade-model-plate">
        <!-- 面板-首行 -->
        <div
          v-for="item in adc_list"
          :key="item.id"
          class="ade-model-plate-line font-14"
        >
          <div
            :class="{
              'ade-model-plate-line-name': true,
              'color-prompt': !item.canModify,
            }"
          >
            {{ item.name }}
          </div>
          <a-cascader
            v-if="item.value.constructor['name'] === 'Array'"
            wrapper="ade-model-plate-line-picker"
            :options="options"
            v-model="shengshiqu"
            placeholder="选择所在区域"
            @blur.native.capture="regionChange"
          ></a-cascader>
          <input
            v-else-if="item.canModify"
            class="ade-model-plate-line-input"
            :placeholder="item.prompt"
            v-model="item.value"
            @change="saveit"
          />
          <div v-else class="ade-model-plate-line-onlineShow color-prompt">
            {{ item.value }}
          </div>
        </div>
        <div class="ade-model-plate-line font-14">
          <div class="ade-model-plate-line-name">快捷输入</div>
          <textarea
            cols="60"
            rows="3"
            class="ade-model-plate-line-input"
            style="height: 50px"
            placeholder="请粘贴淘宝地址以快速输入"
            v-model="fastString"
            @change="fastChange"
          />
        </div>
        <div
          class="o_con_prod_pl_btn_view bgcolor-gradient-right font-12"
          @click="func_moren()"
        >
          使用默认地址
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import AddressParse from "address-parse";
import json from "@/seal/json/zip-code.json";
export default {
  name: "addressCreate1",
  props: {},
  data() {
    return {
      adc_show: 0,
      options: [],
      userinfo:false,
      shengshiqu: ["", "", ""],
      adc_list: [
        {
          id: "adel01",
          canModify: true,
          name: "联系人",
          value: "",
          prompt: "",
        },
        {
          id: "adel02",
          canModify: true,
          name: "联系电话",
          value: "",
          prompt: "",
        },
        {
          id: "adel03",
          canModify: true,
          name: "收货公司",
          value: "",
          prompt: "",
        },
        {
          id: "adel06",
          canModify: true,
          name: "收货地区",
          value: ["", "", ""],
          prompt: "",
        },
        {
          id: "adel04",
          canModify: true,
          name: "收货地址",
          value: "",
          prompt: "详细地址",
        },
      ],
      temp_index: -1,
      fastString: "",
    };
  },
  methods: {
    saveit() {
      this.vadc_save();
    },
    // show方法l
    regionChange(event) {
      let str = event.target.innerText;
      str.replace(/\s+/g, "");
      if (str) {
        const arr = str.split("/");
        if ((arr.length = 3)) {
          this.adc_list[3]["value"] = [arr[0], arr[1], arr[2]];
        }
      } else {
        this.adc_list[3]["value"] = ["", "", ""];
      }
      this.vadc_save();
    },
    vadc_json(index) {
      this.options = json;
      if (this.fastString && this.fastString !== "") {
        this.fastChange1(this.fastString);
      }

      this.vadc_save();
    },
    vadc_Change(index) {
      this.temp_index = index;
      this.adc_show = 1;
    },
    vadc_closes() {
      this.vadc_close();
    },
    // close方法
    vadc_close() {
      this.adc_show = 2;
      setTimeout(() => {
        this.adc_show = 0;
      }, 200);
    },
    // 保存
    vadc_save() {
      this.$emit("vadc", this.adc_list);
      for (let i in this.adc_list) {
        if (
          this.adc_list[i]["id"] !== "adel06" &&
          this.adc_list[i]["id"] !== "adel03" &&
          (!this.adc_list[i]["value"] || this.adc_list[i]["value"].length < 1)
        ) {
          return;
        } else if (this.adc_list[i]["id"] === "adel06") {
          for (let j in this.adc_list[i]["value"]) {
            if (
              !this.adc_list[i]["value"][j] ||
              this.adc_list[i]["value"][j].length < 1
            ) {
              return;
            }
          }
        }
      }
      // 接收来自父组件的用户信息，并赋值
      this.$parent.func_createAddress(
        {
          Address: this.adc_list[4]["value"],
          Attn: this.adc_list[0]["value"],
          Company: this.adc_list[2]["value"],
          Mobile: this.adc_list[1]["value"],
          province: this.adc_list[3]["value"][0],
          city: this.adc_list[3]["value"][1],
          area: this.adc_list[3]["value"][2],
        },
        this.temp_index
      );
    },
    fastChange(event) {
      if (event.srcElement.value) {
        const [jsonaa] = AddressParse.parse(event.srcElement.value);
        this.adc_list[0].value = jsonaa.name ? jsonaa.name : "";
        this.adc_list[1].value = jsonaa.mobile ? jsonaa.mobile : "";
        let adc = ["", "", ""];
        let shengshiqu = ["", "", ""];
        this.adc_list[4].value = jsonaa.details ? jsonaa.details : "";
        for (let i in this.options) {
          if (jsonaa.province == this.options[i].label) {
            shengshiqu[0] = this.options[i].value;
            adc[0] = this.options[i].label;
            for (let j in this.options[i].children) {
              if (jsonaa.city == this.options[i].children[j].label) {
                shengshiqu[1] = this.options[i].children[j].value;
                adc[1] = this.options[i].children[j].label;
                for (let n in this.options[i].children[j].children) {
                  if (
                    jsonaa.area == this.options[i].children[j].children[n].label
                  ) {
                    shengshiqu[2] =
                      this.options[i].children[j].children[n].value;
                    adc[2] = this.options[i].children[j].children[n].label;
                  }
                }
              }
            }
          }
        }
        this.adc_list[3].value = adc;
        this.shengshiqu = shengshiqu;
        this.vadc_save();
      }
    },
    func_moren() {
      this.userinfo = this.STORAGE.get("g_userInfo");
      this.adc_list[0].value =this.userinfo.attn
      this.adc_list[1].value =this.userinfo.tel
      this.adc_list[2].value =this.userinfo.company
      let arr = ["", "", ""]
      let brr =["", "", ""]
      arr[0]=this.userinfo.province
      arr[1]=this.userinfo.city
      arr[2]= this.userinfo.area
      this.adc_list[3].value =arr
      for (let i in this.options) {
          if (this.userinfo.province == this.options[i].label) {
            brr[0] = this.options[i].value;
            for (let j in this.options[i].children) {
              if (this.userinfo.city == this.options[i].children[j].label) {
                brr[1] = this.options[i].children[j].value;
                for (let n in this.options[i].children[j].children) {
                  if (
                    this.userinfo.area == this.options[i].children[j].children[n].label
                  ) {
                    brr[2] =
                      this.options[i].children[j].children[n].value;
                  }
                }
              }
            }
          }
        }
      this.shengshiqu = brr
      this.adc_list[4].value =this.userinfo.address
      this.vadc_save();
    },
    fastChange1(title) {
      const [jsonaa] = AddressParse.parse(title);
      this.adc_list[0].value = jsonaa.name ? jsonaa.name : "";
      this.adc_list[1].value = jsonaa.mobile ? jsonaa.mobile : "";
      let adc = ["", "", ""];
      let shengshiqu = ["", "", ""];
      this.adc_list[4].value = jsonaa.details ? jsonaa.details : "";
      for (let i in this.options) {
        if (jsonaa.province == this.options[i].label) {
          shengshiqu[0] = this.options[i].value;
          adc[0] = this.options[i].label;
          for (let j in this.options[i].children) {
            if (jsonaa.city == this.options[i].children[j].label) {
              shengshiqu[1] = this.options[i].children[j].value;
              adc[1] = this.options[i].children[j].label;
              for (let n in this.options[i].children[j].children) {
                if (
                  jsonaa.area == this.options[i].children[j].children[n].label
                ) {
                  shengshiqu[2] = this.options[i].children[j].children[n].value;
                  adc[2] = this.options[i].children[j].children[n].label;
                }
              }
            }
          }
        }
      }
      this.adc_list[3].value = adc;
      this.shengshiqu = shengshiqu;
      this.vadc_save();
    },
    // setContent(json) {
    //   //接收显示通过userinfo得到的用户信息
    // },
  },
};
</script>
<style scoped>
.o_con_prod_pl_btn_view {
	height:33px; color:#ffffff; margin:2px 0 2px 10px;
	display:inline-flex; justify-content:center; align-items:center;
	padding:0 16px;
	border-radius:60px;
	cursor:pointer;
	transition: all 0.2s ease-in-out 0s;
}
.o_con_prod_pl_btn_view:hover {
	opacity:0.8;
}
.ade-mask {
  background: rgba(0, 0, 0, 0);
  width: 100%;
  height: 100vh;

  animation: adeMaskShow 0.2s linear 0s forwards;
  z-index: 210;
}
@keyframes adeMaskShow {
  from {
    background: rgba(0, 0, 0, 0);
  }
  to {
    background: rgba(0, 0, 0, 0.5);
  }
}
.ade-mask-close {
  animation: adeMaskClose 0.2s linear 0s forwards;
}
@keyframes adeMaskClose {
  from {
    background: rgba(0, 0, 0, 0.5);
  }
  to {
    background: rgba(0, 0, 0, 0);
  }
}
.ade-model-show {
  transform: translateY(-0%);
}

.ade-model-visual {
  height: 200px;
  overflow: hidden;
}
.ade-model-visual-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.ade-model-visual-layo-view01 {
  width: 20px;
  height: 26px;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
}
.ade-model-visual-layo-view01-line {
  background: rgba(255, 255, 255, 0.9);
  width: 6px;
  height: 100%;
  border-radius: 10px;
}
.ade-model-visual-layo-view02 {
  background: rgba(255, 255, 255, 0.9);
  width: 6px;
  height: 20px;
  border-radius: 10px;
}
.ade-model-visual-layout2 {
  background: rgba(255, 255, 255, 1);
  width: 160px;
  height: 16px;
  transform: scaleY(1.3) perspective(0.4em) rotateX(5deg);
  transform-origin: bottom;
}

.ade-model-plate {
  width: 500px;
  padding: 0 20px 20px 20px;
}
.ade-model-plate-title {
  width: 100%;
  padding: 16px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.ade-model-plate-tit-right {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
}
.ade-model-plate-tit-rig-btn {
  color: #ffffff;
  margin: 0 0 0 4px;
  box-sizing: border-box;
  padding: 4px 10px;
  border-radius: 4px;
  border: 1px solid #eeeeee;
  cursor: pointer;
}
.ade-model-plate-tit-rig-btn:active {
  opacity: 0.8;
}
.ade-model-plate-tit-rig-btn-no {
  background: #aaaaaa;
}
.ade-model-plate-line {
  width: 100%;
  margin: 10px 0;
  display: flex;
  align-items: center;
}
.ade-model-plate-line-name {
  width: 76px;
}
.ade-model-plate-line-input {
  width: calc(100% - 76px);
  height: 26px;
  border-radius: 0;
  border-style: solid;
  border-color: #cccccc;
}
.ade-model-plate-line-onlineShow {
  width: calc(100% - 76px);
  height: 26px;
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 11px;
}
.ade-model-plate-line-picker {
  width: calc(100% - 76px);
  height: 26px;
  box-sizing: border-box;
  padding-left: 11px;
  border-width: 0 0 1px 0;
  border-style: solid;
  border-color: #cccccc;
}
</style>




// WEBPACK FOOTER //
// src/components/address/addressCreate1.vue